<template>
  <div>
    <div v-if="!hideTotal" class="row mt-2 d-flex justify-content-end">        
        <div style="width: 60px; height: 60px">          
          <i class="far fa-check-circle fa-3x color-green pt-3" />
        </div>
        <div class="pr-3 ml-2 mt-2">
          <div class="color-secondary-6 font-14">
            Monto Total:
          </div>
          <div>
            <div>
              <span class="color-green font-weight-bold font-22">
                {{ total }}
              </span>             
            </div>
          </div>
        </div>    
    </div>  
   
    <div class="row mt-2 d-flex justify-content-end">    
      <template v-if="!readonly">
        <div class="col-2 my-auto">
          <ActionButton
            variant="success mt-2"
            :i="`fas fa-file-plus`"
            responsive
            @click="add"
          >
            Añadir
          </ActionButton>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import { price } from '@/utils/filters.js';

export default {
  name: 'TotalRow',
  components: { ActionButton },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    readonly: { type: Boolean, default: false },
    hideTotal: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    total() {
      let total = 0;

      if (this.items.length > 0) {
        this.items.forEach((x) => {
          let subTotal = Number(x.subtotal ?? x.subTotal) || 0;
          let cost = Number(x.cost) || 0;

          if (subTotal === 0) {
            if (x.frequency > 0) {
              subTotal = Number(x.frequency) * cost;
            } else {
              // if doens't have frequency, then sub total will be cost until the user set the frequency in PEI
              subTotal = cost;
            }
          }
          
          total = total + subTotal;
        });
      }
      return price(total);
    },
  },
  methods: {
    add() {
      this.$emit('add');
    },
  },
};
</script>

